import EventTarget from '@ungap/event-target';

window.EventTarget = EventTarget;
